import script from "./LoginForgetView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginForgetView.vue?vue&type=script&lang=ts&setup=true"

import "./LoginForgetView.vue?vue&type=style&index=0&id=52cfb07d&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52cfb07d"]])

export default __exports__